import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { getThemeClassNames } from '@cognite/cogs-utils';
import { ActionListItemChildren } from './elements.js';

/**
 * Item component for ActionList that can be used as a link just like an anchor tag.
 */
var ActionListLinkItem = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var children = _a.children,
    className = _a.className,
    inverted = _a.inverted,
    icon = _a.icon,
    promoChipOptions = _a.promoChipOptions,
    counterChipOptions = _a.counterChipOptions,
    textOverflowTooltipOptions = _a.textOverflowTooltipOptions,
    infoTooltipOptions = _a.infoTooltipOptions,
    toggled = _a.toggled,
    otherProps = __rest(_a, ["children", "className", "inverted", "icon", "promoChipOptions", "counterChipOptions", "textOverflowTooltipOptions", "infoTooltipOptions", "toggled"]);
  return jsx("a", Object.assign({
    ref: ref,
    rel: otherProps.target === '_blank' ? 'noreferrer' : otherProps.target
  }, otherProps, {
    className: classnames.apply(undefined, ['cogs-lab', 'cogs-actionlist-item'].concat(_toConsumableArray(getThemeClassNames(inverted)), [toggled && 'cogs-actionlist-item--toggled', className])),
    children: jsx(ActionListItemChildren, {
      inverted: inverted,
      icon: icon,
      promoChipOptions: promoChipOptions,
      counterChipOptions: counterChipOptions,
      textOverflowTooltipOptions: textOverflowTooltipOptions,
      infoTooltipOptions: infoTooltipOptions,
      children: children
    })
  }));
});

export { ActionListLinkItem };
